import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import ModifyAddress from 'components/form/AddressSelector/Items/ModifyAddress/ModifyAddress';

const enhance = compose(withTranslation('AddressSelector'));

export default enhance(ModifyAddress);
